import {
    FETCH_ACTIVE_ORDERS,
    FETCH_ORDER,
    CLEAR_NEW_ORDERS,
    CLOSE_ORDER,
    CANCEL_ORDER,
    CREDIT_PAYMENT,
    RESEND_ORDER,
    TOGGLE_SOUND_NOTIFICATIONS,
    GENERATE_RECEIPT,
    SEND_TEST_ORDER
} from '../types';
import api from '../api';
import moment from 'moment';

export const fetchActiveOrders = (restId, startDate, endDate, preventLoading = false) => {
    if (!restId) return { type: 'NOTHING' };

    return {
        type: FETCH_ACTIVE_ORDERS,
        payload: api.restaurant.get(restId).orders.getAll(startDate, endDate),
        meta: { preventLoading }
    };
};

export const fetchOrder = (restId, orderId, onSuccess, onFailure) => {
    return {
        type: FETCH_ORDER,
        payload: api.restaurant.get(restId).orders.get(orderId),
        meta: {
            onSuccess, onFailure
        }
    };
};

export const clearNewOrders = () => {
    return { type: CLEAR_NEW_ORDERS };
};

export const closeOrder = (restId, orderGuid) => {
    return {
        type: CLOSE_ORDER,
        payload: api.restaurant.get(restId).orders.close(orderGuid),
        meta: {
            toastSuccess: true,
            // onSuccess: () => {
            //     window.location.href = `/restaurant/${restId}/orders`;
            // }
        }
    };
};

export const cancelOrder = (restId, orderGuid, reason, details, notifyUser) => {
    return {
        type: CANCEL_ORDER,
        payload: api.restaurant.get(restId).orders.cancel(orderGuid, reason, details, notifyUser),
        meta: {
            toastSuccess: true,
            // onSuccess: () => {
            //     window.location.href = `/restaurant/${restId}/orders`;
            // }
        }
    };
};

export const creditPayment = (restId, creditForm) => {
    return {
        type: CREDIT_PAYMENT,
        payload: api.restaurant.get(restId).orders.credit(creditForm),
        meta: {
            toastSuccess: true,
            dispatchOnSuccess: () => fetchActiveOrders(restId, moment().startOf('day').subtract(7, 'days').format(), moment().format(), true)
            // onSuccess: () => {
            //     window.location.href = `/restaurant/${restId}/orders`;
            // }
        }
    };
};

export const resendOrder = (restId, orderId) => {
    return {
        type: RESEND_ORDER,
        payload: api.restaurant.get(restId).orders.resend(orderId),
        meta: {
            toastSuccess: true,
            orderId,
            onSuccess: (result) => console.log(result)
        }
    };
};

export const toggleSoundNotifications = () => {
    return {
        type: TOGGLE_SOUND_NOTIFICATIONS
    };
};

export const generateReceipt = (restId, orderId, language, replacementVoucher, onSuccess) => {
    return {
        type: GENERATE_RECEIPT,
        payload: api.restaurant.get(restId).orders.receipt(orderId, language, replacementVoucher),
        meta: { onSuccess }
    };
};

export const sendTestOrder = ({ checkout, cart, shouldSendPayments }) => {
    return {
        type: SEND_TEST_ORDER,
        payload: api.restaurant.get(checkout.restaurantId).orders.sendTestOrder(checkout, cart, shouldSendPayments),
        meta: {
            toastSuccess: true
        }
    };
};